import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { articleContentStyles, getUserAgentStyles } from "./articleStyles";

export default function ArticleBody({ content }) {
  useEffect(() => {
    const iPhoneStyles = getUserAgentStyles();
    if (iPhoneStyles) {
      const style = document.createElement("style");
      style.textContent = iPhoneStyles;
      document.head.appendChild(style);

      return () => {
        document.head.removeChild(style);
      };
    }
  }, []);

  return (
    <Box 
      sx={{ 
        backgroundColor: "background.paper",
        borderRadius: "16px",
        padding: { xs: "1.5rem", md: "2rem" },
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box className="tiptap-content" sx={articleContentStyles}>
        {content}
      </Box>
    </Box>
  );
}
